import React, { useState, useCallback } from 'react';

interface DebugInfo {
  timestamp: number;
  eventType: string;
  eventDetails: any;
  componentState: any;
  error?: Error;
}

export const useDebug = () => {
  const [debugLog, setDebugLog] = useState<DebugInfo[]>([]);

  const logEvent = useCallback((eventType: string, eventDetails: any, componentState: any, error?: Error) => {
    const debugInfo: DebugInfo = {
      timestamp: Date.now(),
      eventType,
      eventDetails,
      componentState,
      error
    };
    setDebugLog(prev => [debugInfo, ...prev].slice(0, 100)); // Keep last 100 logs
    if (process.env.NODE_ENV === 'development') {
        console.log('[DEBUG]', debugInfo);
    }
  }, []);

  const DebugPanel = () => {
    if (process.env.NODE_ENV !== 'development') return null;

    return (
      <div style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '300px',
        height: '200px',
        backgroundColor: 'rgba(0,0,0,0.8)',
        color: 'white',
        overflowY: 'auto',
        padding: '10px',
        fontSize: '12px',
        zIndex: 10000 // Ensure it's above other elements
      }}>
        <h4>Debug Log</h4>
        {debugLog.map((log, index) => (
          <div key={index} style={{ marginBottom: '5px', borderBottom: '1px dashed grey', paddingBottom: '3px' }}>
            <div>{new Date(log.timestamp).toLocaleTimeString()}</div>
            <div><strong>{log.eventType}</strong></div>
            {log.error && <div style={{ color: 'red' }}>Error: {log.error.message}</div>}
            {/* Optionally log details - can be verbose */}
            {/* <pre style={{ fontSize: '10px', whiteSpace: 'pre-wrap' }}>{JSON.stringify(log.eventDetails, null, 2)}</pre> */}
          </div>
        ))}
      </div>
    );
  };

  return { logEvent, DebugPanel };
}; 